import clsx from 'clsx';
import { FC, ReactNode, VFC } from 'react';
import ArrowIcon from '../../assets/icons/arrow.svg?react';
import { AlertFooter } from '../../components/AlertFooter';
import { Button } from '../../components/Button';
import {
  nextPage,
  previousPage,
  submitQuestionnaire,
  useInspectionPages,
  useIsCurrentAnswerValid,
} from '../../services/inspection';
import styles from './Inspection.module.css';
import { InspectionAlert } from './InspectionAlert';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

export const ErrorAlert = () => {
  const navigate = useNavigate();
  return (
    <InspectionAlert open onClose={() => navigate('/')}>
      <div className={styles.header}>
        <FormattedMessage id="Error.Oops" />
      </div>
      <FormattedMessage
        tagName="div"
        id="Inspection.Submit.Error"
        values={{
          b: (chunks) => <strong>{chunks}</strong>,
          br: <br />,
        }}
      />
      <AlertFooter>
        <Button onClick={submitQuestionnaire}>
          <FormattedMessage id="Retry" />
        </Button>
      </AlertFooter>
    </InspectionAlert>
  );
};

export const DoneAlert = () => {
  const navigate = useNavigate();
  return (
    <InspectionAlert open>
      <div className={styles.header}>
        <FormattedMessage id="Done" />
      </div>
      <FormattedMessage
        tagName="div"
        id="Inspection.Submit.Success"
        values={{
          b: (chunks) => <strong>{chunks}</strong>,
          br: <br />,
        }}
      />
      <AlertFooter>
        <Button variant="text" onClick={() => navigate('/')}>
          <FormattedMessage id="Close" />
        </Button>
      </AlertFooter>
    </InspectionAlert>
  );
};

export interface QuestionTitleProps {
  children?: ReactNode;
  index: number;
}

export const QuestionTitle: FC<QuestionTitleProps> = ({ children, index }) => (
  <ol
    className={clsx(styles.questionTitle, index > 9 && styles.doubleDigits)}
    start={index}
  >
    <li>{children}</li>
  </ol>
);

export const Footer: VFC = () => {
  const valid = useIsCurrentAnswerValid();
  const { current, total } = useInspectionPages();
  const { $t } = useIntl();
  const navigate = useNavigate();

  return (
    <div className={styles.btns}>
      <Button
        variant="outlined"
        onClick={current ? previousPage : () => navigate('/')}
        title={$t({ id: 'Back' })}
      >
        <ArrowIcon className={styles.arrow} />
      </Button>
      {current + 1 === total ? (
        <Button onClick={submitQuestionnaire} disabled={!valid}>
          <FormattedMessage id="Finish" />
        </Button>
      ) : (
        <Button onClick={nextPage} disabled={!valid}>
          <FormattedMessage id="Next" />
        </Button>
      )}
    </div>
  );
};
